import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';
let config = new SvgFactoryConfig();
config.viewBox = "0 0 26 21";
config.iconName = "comments-widget";
config.shape = `
<path fill="var(--fill)" fill-rule="evenodd" stroke="var(--stroke)" d="M18.178 16.82l-.105 3.353-3.943-3.353H2a1 1 0 0 1-1-1V1.526a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1V15.82a1 1 0 0 1-1 1h-5.822z"/>
`;
let CommentsWidgetSVG = new SvgFactory(config);
export default CommentsWidgetSVG;


